import { render, staticRenderFns } from "./ruku.vue?vue&type=template&id=37058d53"
import script from "./ruku.vue?vue&type=script&lang=js"
export * from "./ruku.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports